import { Container, Textarea, Typography } from '@design-system';
import { Checkbox } from '@design-system';
import React from 'react';

import './PointageDetails.scss';

export type PointageDetailsProps = {
    isUsageVehiculeChecked: boolean;
    setIsUsageVehiculeChecked: (isUsageVehiculeChecked: boolean) => void;
    comment: string;
    setComment: (comment: string) => void;
};

export const PointageDetails: React.FC<PointageDetailsProps> = ({
    isUsageVehiculeChecked,
    setIsUsageVehiculeChecked,
    comment,
    setComment
}) => {
    return (
        <div className="pointage-details">
            <div className="pointage-details-header">
                <Typography intrinsic="h2" defaultSpacing>
                    Détails
                </Typography>
                <Checkbox
                    label="Usage d'un véhicule personnel"
                    checked={isUsageVehiculeChecked}
                    onChange={() => setIsUsageVehiculeChecked(!isUsageVehiculeChecked)}
                />
            </div>
            <Container padding="small-medium">
                <Textarea
                    placeholder="Ajouter un commentaire"
                    value={comment}
                    onValueChange={setComment}
                    className="pointage-details-comment"
                />
            </Container>
        </div>
    );
};
